import { render } from "./main-nav.vue?vue&type=template&id=594fbf48&scoped=true"
import script from "./main-nav.vue?vue&type=script&lang=js"
export * from "./main-nav.vue?vue&type=script&lang=js"

import "./main-nav.vue?vue&type=style&index=0&id=594fbf48&scoped=true&lang=css"

import exportComponent from "/Users/alexey/Projects/gambody-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594fbf48"]])

export default __exports__